// extracted by mini-css-extract-plugin
export default {"root":"Diploma_root__EpoAp","egg":"Diploma_egg__JCWhJ","image":"Diploma_image__LT5sW","grid":"Diploma_grid__3Prmr"};